export default __webpack_public_path__ + "static/hotel-951599_1280-6419830fb36dab52330221fb15e57ea6.png";